var _circle, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 67,
    viewBox: "0 0 118 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 59,
    r: 59,
    fill: "#E1EAEC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_610_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6663 40.6667H27.333C24.5663 40.6667 22.333 42.9001 22.333 45.6667V72.3334C22.333 75.1001 24.5663 77.3334 27.333 77.3334H40.6663C43.433 77.3334 45.6663 75.1001 45.6663 72.3334V45.6667C45.6663 42.9001 43.433 40.6667 40.6663 40.6667ZM37.333 74.0001H30.6663V72.3334H37.333V74.0001ZM42.7497 69.0001H25.2497V45.6667H42.7497V69.0001Z",
    fill: "#0B71C3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_610_216)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.3333 70.5001C98.4417 70.5001 100.147 68.7751 100.147 66.6667L100.167 47.5001C100.167 45.3917 98.4417 43.6667 96.3333 43.6667H65.6667C63.5583 43.6667 61.8333 45.3917 61.8333 47.5001V66.6667C61.8333 68.7751 63.5583 70.5001 65.6667 70.5001H58V74.3334H104V70.5001H96.3333ZM65.6667 47.5001H96.3333V66.6667H65.6667V47.5001Z",
    fill: "#0B71C3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_610_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(14 39)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_610_216"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white",
    transform: "translate(58 36)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivices);
export default __webpack_public_path__ + "static/media/divices.a9e3d3ff509f309cb14b9fef9c296809.svg";
export { ForwardRef as ReactComponent };